var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 3.38625C25.875 3.38625 23.6048 4.72725 22.3425 5.1075C21.665 4.32845 20.7645 3.77628 19.7629 3.52567C18.7613 3.27506 17.7069 3.3381 16.7423 3.70626C15.7777 4.07443 14.9495 4.72995 14.3696 5.58418C13.7897 6.43841 13.4862 7.45013 13.5 8.4825V9.6075C11.523 9.65877 9.56393 9.22029 7.79738 8.33113C6.03084 7.44197 4.51161 6.12972 3.375 4.51125C3.375 4.51125 -1.125 14.6363 9 19.1363C6.68309 20.709 3.92305 21.4975 1.125 21.3863C11.25 27.0113 23.625 21.3863 23.625 8.44875C23.625 8.136 23.5935 7.82325 23.535 7.515C24.6825 6.38325 25.875 3.38625 25.875 3.38625Z",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter2);
export default __webpack_public_path__ + "static/media/twitter2.af956686dc1d83bce9590bb5a42fcb70.svg";
export { ForwardRef as ReactComponent };